"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegator",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "fromDelegate",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "toDelegate",
                type: "address",
            },
        ],
        name: "DelegateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "delegate",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "previousBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newBalance",
                type: "uint256",
            },
        ],
        name: "DelegateVotesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DescriptorLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsDescriptorMinimal",
                name: "descriptor",
                type: "address",
            },
        ],
        name: "DescriptorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "MinterLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "NounBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "body",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "glasses",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "skill",
                        type: "uint48",
                    },
                ],
                indexed: false,
                internalType: "struct INounsSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "NounCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "noundersDAO",
                type: "address",
            },
        ],
        name: "NoundersDAOUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "SeederLocked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract INounsSeeder",
                name: "seeder",
                type: "address",
            },
        ],
        name: "SeederUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DELEGATION_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "checkpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "fromBlock",
                type: "uint32",
            },
            {
                internalType: "uint96",
                name: "votes",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "contractURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
        ],
        name: "delegate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegatee",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "nonce",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "expiry",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "delegateBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "delegates",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "descriptor",
        outputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getCurrentVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
        ],
        name: "getPriorVotes",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDescriptorLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isMinterLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isSeederLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lockSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "noundersDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "numCheckpoints",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seeder",
        outputs: [
            {
                internalType: "contract INounsSeeder",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "seeds",
        outputs: [
            {
                internalType: "uint48",
                name: "background",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "body",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "head",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "glasses",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "skill",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "newContractURI",
                type: "string",
            },
        ],
        name: "setContractURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsDescriptorMinimal",
                name: "_descriptor",
                type: "address",
            },
        ],
        name: "setDescriptor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_noundersDAO",
                type: "address",
            },
        ],
        name: "setNoundersDAO",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract INounsSeeder",
                name: "_seeder",
                type: "address",
            },
        ],
        name: "setSeeder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "tokenOfOwnerByIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegator",
                type: "address",
            },
        ],
        name: "votesToDelegate",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_noundersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.deploy(_noundersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(_noundersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides) {
        return super.getDeployTransaction(_noundersDAO, _minter, _descriptor, _seeder, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsToken__factory = NounsToken__factory;
NounsToken__factory.bytecode = _bytecode;
NounsToken__factory.abi = _abi;
